module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";